<!--  -->
<template>
  <div style="width: 100%; height: 100%; overflow: hidden">
    <div id="china" style="width: 100%; height: 100%"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import '@/assets/js/china'
import lfdImgUrl from '@/assets/imgs/ydk/LFD_store.png'
import flkImgUrl from '@/assets/imgs/ydk/FLK_store.png'
// import { geoCoordMap } from '@/assets/js/geoMap'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      chart: {}
    }
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created () {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    // 地理位置信息
    var geoCoordMap = {
      lfd: [117.760945, 36.000893],
      flk: [118.760945, 37.001893]
    }
    var geoCoordData = [
      {
        text: '利丰达库区',
        name: 'lfd',
        value: '35',
        info: {
          img: lfdImgUrl
        }
      },
      {
        text: '丰利库区',
        name: 'flk',
        value: '35',
        info: {
          img: flkImgUrl
        }
      }
    ]
    var convertData = function (data) {
      var res = []
      for (var i = 0; i < data.length; i++) {
        var geoCoord = geoCoordMap[data[i].name]
        if (geoCoord) {
          res.push({
            name: data[i].text,
            value: geoCoord,
            info: data[i].info || {}
          })
        }
      }
      return res
    }
    var option = {
      backgroundColor: 'transparent',
      tooltip: {
        trigger: 'item',
        triggerOn: 'click',
        showDelay: 0, // 浮层显示的延迟
        transitionDuration: 0.2, // 提示框浮层的移动动画过渡时间
        enterable: true,
        formatter: function (params) {
          console.log(params)
          if (params.data) {
            let info = params.data.info || {}
            let html = `
          <div style="width:200px;height:180px;">
            <img src="${info.img}" alt="">
            <div style="text-align:center">
            <span>${params.name}</span>
          </div>`
            return html
          } else {
          }
        }
      },
      // 地理坐标
      geo: {
        map: 'china',
        type: 'map',
        aspectScale: 0.75, // 长宽比
        roam: true,
        emphasis: {
          disabled: true
        },
        silent: false
      },
      series: [
        {
          map: 'china',
          type: 'map',
          roam: true,
          emphasis: {
            disabled: true
          },
          silent: false
        },

        // 标记 图形 原点 scatter点 effectScatter涟漪特效
        {
          type: 'scatter',
          coordinateSystem: 'geo',
          symbolSize: 5,
          label: {
            normal: {
              formatter: '{b}',
              position: 'right',
              show: true
            },
            emphasis: {
              show: true
            }
          },
          hoverAnimation: true,
          itemStyle: {
            normal: {
              color: '#fff'
            }
          },
          zlevel: 1,
          data: convertData(geoCoordData)
        },
        // 标记图形 大头针
        {
          type: 'scatter',
          coordinateSystem: 'geo',
          symbol: 'pin', // 标记的图形 图片参考：https://echarts.apache.org/zh/option.html#series-scatter.symbol
          symbolSize: [40, 40],
          label: {
            normal: {
              show: true,
              textStyle: {
                color: '#fff',
                fontSize: 9
              },
              formatter (value) {
                return ''
              }
            }
          },
          hoverAnimation: true,
          itemStyle: {
            normal: {
              color: '#DA000FFF' // 标志颜色
              // shadowBlur: 10,
              // shadowColor: '#333'
            }
          },
          zlevel: 1,
          data: convertData(geoCoordData)
        }
      ]
    }
    this.chart = echarts.init(document.querySelector('#china'))
    this.chart.setOption(option)

    // 因为地图阴影是geo，地图色块区域是series，拖拽和放缩会造成不同步，要设置到同步
    this.chart.on('georoam', (params) => {
      var option = this.chart.getOption() // 获得option对象
      if (params.zoom != null && params.zoom !== undefined) {
        // 捕捉到缩放时
        option.geo[0].zoom = option.series[0].zoom // 下层geo的缩放等级跟着上层的geo一起改变
        option.geo[0].center = option.series[0].center // 下层的geo的中心位置随着上层geo一起改变
      } else {
        // 捕捉到拖曳时
        option.geo[0].center = option.series[0].center // 下层的geo的中心位置随着上层geo一起改变
      }
      // myChart.dispatchAction({
      //   type: 'restore'
      // })
      this.chart.setOption(option) // 设置option
    })
    window.addEventListener('resize', () => {
      this.chart.resize()
    })
  },
  beforeCreate () {}, // 生命周期 - 创建之前
  beforeMount () {}, // 生命周期 - 挂载之前
  beforeUpdate () {}, // 生命周期 - 更新之前
  updated () {}, // 生命周期 - 更新之后
  beforeDestroy () {}, // 生命周期 - 销毁之前
  destroyed () {}, // 生命周期 - 销毁完成
  activated () {} // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
</style>
